import React from 'react'
import MainHeader from '../components/MainHeader/MainHeader'

function ErrorViewer({msg}) {
  return (
    <>
       <MainHeader />
        <div className="container mt-7">
          <div className="row">
            <div className="col-lg-12">
              <div className="d-flex flex-column justify-content-center align-items-center flex-nowrap min-vh-100">
                <span className="fw-bold fs-4 text-light">{msg}</span>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default ErrorViewer
